export default function forEach(arr, callback) {
  var i = 0;
  var l = arr.length;
  for (; i < l; i++) {
    callback(arr[i], i);
  }
}